import React from 'react'
import { Box, Container, Grid, Paper, Typography } from '@mui/material'
import { useTranslation } from 'next-i18next'
import Image from 'next/image'
import NextLink from '@imports/NextLink'

import Logo from '@assets/logo.png'
import LogoSmall from '@assets/logo-small.png'

function CreateAccountLayout({ children, title, subtitle }) {
  const { t } = useTranslation(['common', 'register'])
  return (
    <Box py={4}>
      <Container maxWidth="md">
        <Paper sx={{ borderRadius: 4 }}>
          <Box
            py={{ xs: 4, md: 5 }}
            px={{ xs: 3, md: 8 }}
          >
            <Grid
              container
              justifyContent="space-between"
            >
              <Grid
                item
                xs
              >
                <Typography
                  variant="h3"
                  sx={{ fontSize: { xs: '25px !important', md: '40px !important' }, mb: 2 }}
                  textTransform="capitalize"
                >
                  {title || t('register:create_your_account')}
                </Typography>
                <Typography
                  variant="body1"
                  color="neutral.dark"
                  fontWeight={400}
                >
                  {subtitle || t('register:Get_started_in_just_3_simple_steps')}
                </Typography>
              </Grid>
              <Grid item>
                <Box
                  width={150}
                  sx={{ display: { xs: 'none', sm: 'block' } }}
                >
                  <NextLink
                    href="/"
                    aria-label="home page"
                  >
                    <Image
                      style={{
                        width: '100%',
                        height: 'auto',
                        objectFit: 'contain',
                      }}
                      alt={t('common:blue_assembly_logo')}
                      src={Logo}
                    />
                  </NextLink>
                </Box>
                <Box
                  width={25}
                  sx={{ display: { xs: 'block', sm: 'none' } }}
                >
                  <NextLink
                    href="/"
                    aria-label={t('common:home_page')}
                  >
                    <Image
                      style={{
                        width: '100%',
                        height: 'auto',
                        objectFit: 'contain',
                      }}
                      alt={t('common:blue_assembly_logo')}
                      src={LogoSmall}
                    />
                  </NextLink>
                </Box>
              </Grid>
            </Grid>
            <Box mt={2}>{children}</Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  )
}

export default CreateAccountLayout
